import { FormattedMessage } from "react-intl";
import * as Sentry from "@sentry/react";

import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import style from "./style.module.css";

interface IframeModalProps {
  isOpen: boolean;
  onClose: () => void;
  url?: string;
  title: string;
}

export function IframeModal({ isOpen, onClose, url = "", title }: IframeModalProps) {
  if (!url) {
    Sentry.captureMessage(`Missing URL configuration for "${title}"`);
    return (
      <BasicModal isModalOpen={isOpen} handleCancel={onClose} footer={false}>
        <p className={style.error}>
          <FormattedMessage
            id="candidate.errors.iframeLoadError"
            defaultMessage='Unable to load "{title}". Please try again later.'
            values={{ title }}
          />
        </p>
      </BasicModal>
    );
  }

  return (
    <BasicModal isModalOpen={isOpen} handleCancel={onClose} footer={false}>
      <iframe src={url} title={title} className={style.iframe} />
    </BasicModal>
  );
}
